if (!customElements.get('scroll-top')) {
  class ScrollTop extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
    }
  }

  customElements.define('scroll-top', ScrollTop);
}
